import { Component, OnInit, OnDestroy } from "@angular/core";
import { Subscription } from "rxjs";
import { DatePipe } from "@angular/common";

import { ConfirmationService } from "primeng/api";
//import { DialogService } from 'primeng/dynamicdialog';
//import { Table } from 'primeng/table';
//import { Dropdown } from "primeng/dropdown";

import { UserService } from "../../../shared/services/user.service";
import { PersonSelectorService } from "../../personselector/personselector.service";

import { DataService_guardiannotification } from "./shared/data.service";

import { wsGuardianNotificationInfo } from "./shared/wsGuardianNotificationInfo";
import { wsGuardianNotificationSendParm } from "./shared/wsGuardianNotificationSendParm";
import { PersonRegisteredUsersRequest } from "./shared/PersonRegisteredUsersRequest";

@Component({
	selector: "app-root",
	templateUrl: "./guardiannotification.component.html",
	styleUrls: ["./guardiannotification.component.css"],
	providers: [ConfirmationService],
})
export class GuardianNotificationComponent implements OnInit, OnDestroy {
	constructor(
		private datepipe: DatePipe,
		private dataService: DataService_guardiannotification,
		private userService: UserService,
		private personselectorService: PersonSelectorService,
		private confirmationService: ConfirmationService
	) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Globals
	//
	//-----------------------------------------------------------------------------------------------------
	private user: any;
	public isBusy: boolean = false;
	public isShowInfo: boolean = false;
	public IsNotificationsForSchoolEnabled: boolean = false;
	public IsStudentSchoolNotificationEnabled: boolean = false;
	public NotificationMessage: string = "";

	public SuccessMessage: string = ""; // "alert alert-success"
	public WarningMessage: string = ""; // "alert alert-warning"
	public ErrorMessage: string = ""; // "alert alert-danger"

	//	Person Selector
	private subscriptionPersonSelect: Subscription;
	public SelectedPerson: any; // From Person Selector

	public wsGuardianNotificationInfo: wsGuardianNotificationInfo;

	public SelectedNotifyLanguageID: number = 1;
	public lstNotifyLanguages: any = [];

	public lstRegUser: any = [];

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnInit
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnInit() {
		this.user = this.userService.getCurrentUser();
		this.loadNotifyLanguages();

		this.subscriptionPersonSelect = this.personselectorService.onPersonSelectChange().subscribe((person) => {
			this.SelectedPerson = person;

			this.SuccessMessage = "";
			this.WarningMessage = "";
			this.ErrorMessage = "";

			this.isBusy = true;
			this.dataService.GuardianNotificationInfoGet(this.SelectedPerson.PersonID).subscribe((data) => this.GuardianNotificationInfoGet_Complete(data));
		});
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnDestroy
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnDestroy() {
		this.subscriptionPersonSelect.unsubscribe();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	GuardianNotificationInfoGet_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	GuardianNotificationInfoGet_Complete(data: any) {
		this.wsGuardianNotificationInfo = data;

		this.IsNotificationsForSchoolEnabled = this.wsGuardianNotificationInfo.IsNotificationsForSchoolEnabled;
		this.IsStudentSchoolNotificationEnabled = this.wsGuardianNotificationInfo.IsStudentSchoolNotificationEnabled;

		if (this.IsNotificationsForSchoolEnabled == false) {
			this.WarningMessage = this.wsGuardianNotificationInfo.NotificationsForSchoolDisableMessage;
		} else {
			if (this.IsStudentSchoolNotificationEnabled == false) {
				this.WarningMessage = "No registration key generated for this student or no Guardians have school notifications turned on for this student.";
			} else {
				this.WarningMessage = "";
			}
		}

		this.SelectedNotifyLanguageID = this.wsGuardianNotificationInfo.NotifyLanguageID;

		var parms: PersonRegisteredUsersRequest = {
			Token: "", // Filled in by server
			PersonID: this.SelectedPerson.PersonID,
			Domain: "", // Filled in by server
			RegAppTypeID: 1, // Parent App
		};
		this.dataService.PersonRegisteredUsersSelectList(parms).subscribe((data) => this.PersonRegisteredUsersSelectList_Complete(data));

		// this.isBusy = false;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	PersonRegisteredUsersSelectList_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	PersonRegisteredUsersSelectList_Complete(data: any) {
		this.lstRegUser = data;

		if (this.lstRegUser.length > 0) {
			this.IsNotificationsForSchoolEnabled = true;
			this.IsStudentSchoolNotificationEnabled = true;
			this.WarningMessage = "";
		}

		this.isBusy = false;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onToggleInfo
	//
	//-----------------------------------------------------------------------------------------------------
	onToggleInfo() {
		this.isShowInfo = !this.isShowInfo;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onSend
	//
	//-----------------------------------------------------------------------------------------------------
	onSend() {
		if (this.IsNotificationsForSchoolEnabled == false) {
			return;
		}

		if (this.IsStudentSchoolNotificationEnabled == false) {
			return;
		}

		if (this.SelectedPerson != null && this.SelectedPerson.PersonID > 0) {
			if (this.NotificationMessage.length > 1) {
				let parms: wsGuardianNotificationSendParm = {
					PersonID: this.SelectedPerson.PersonID,
					Message: this.NotificationMessage,
				};

				this.isBusy = true;
				this.dataService.GuardianNotificationSendNotification(parms).subscribe((data) => this.GuardianNotificationSendNotification_Complete(data));
			} else {
				this.ErrorMessage = "Please enter a notification message.";
			}
		} else {
			this.ErrorMessage = "Please select a student.";
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	GuardianNotificationSendNotification_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	GuardianNotificationSendNotification_Complete(data: any) {
		this.ErrorMessage = data;

		if (this.ErrorMessage == "") {
			this.SuccessMessage = "Notification has been successfully sent.";
		} else {
			this.SuccessMessage = this.ErrorMessage;
		}

		this.isBusy = false;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	loadNotifyLanguages
	//
	//-----------------------------------------------------------------------------------------------------
	loadNotifyLanguages() {
		var result = this.dataService.NotifyLanguageSelectList();
		result.subscribe(
			(response) => {
				this.lstNotifyLanguages = response;
			},
			(error) => {}
		);
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onUpdateLanguage
	//
	//-----------------------------------------------------------------------------------------------------
	onUpdateLanguage() {
		if (this.wsGuardianNotificationInfo == null || this.wsGuardianNotificationInfo.PersonID == null) {
			return;
		}

		this.isBusy = true;

		this.dataService
			.NotifyLanguageModify(this.wsGuardianNotificationInfo.PersonID, this.SelectedNotifyLanguageID)
			.subscribe((data) => this.UpdateLanguageSendNotification_Complete(data));
	}

	UpdateLanguageSendNotification_Complete(data: any) {
		this.SuccessMessage = "";
		this.ErrorMessage = "";

		if (data == true) {
			this.SuccessMessage = "Notification language has been updated successfully.";
		} else {
			this.ErrorMessage = "ERROR: Could not update notification language";
		}

		this.isBusy = false;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Add New Method Here
	//
	//-----------------------------------------------------------------------------------------------------
}
